// @flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  CREATE_HEADER_BANNER: `${env.baseApiUrl}/ui/admin/store/header`,
  GET_HEADER_BANNER: `${env.baseApiUrl}/ui/admin/store/header/:bannerId`,
  UPDATE_HEADER_BANNER: `${env.baseApiUrl}/ui/admin/store/header/:bannerId`,
  DELETE_HEADER_BANNER: `${env.baseApiUrl}/ui/admin/store/header/:bannerId`,
  LIST_HEADER_BANNERS: `${env.baseApiUrl}/ui/admin/store/header`,
});

export const createHeaderBannerApi = postCreator(
  endpoints.CREATE_HEADER_BANNER
);
export const getHeaderBannerApi = getCreator(endpoints.GET_HEADER_BANNER);
export const deleteHeaderBannerApi = deleteCreator(
  endpoints.DELETE_HEADER_BANNER
);
export const listHeaderBannersApi = getCreator(endpoints.LIST_HEADER_BANNERS);
export const updateHeaderBannerApi = putCreator(endpoints.UPDATE_HEADER_BANNER);

export type HeaderBannerRequest = {
  content: string,
  backgroundColor: string,
  textColor: string,
  enabled: boolean,
  buttonEntityType?: 'URL',
  buttonEntityIdentifier?: string,
  buttonContent: string,
};
